/**
 * Configuration field types used throughout the application
 */
export const AppConfigTypes = {
    STRING: "string",
    BOOLEAN: "boolean",
    IMAGE: "image",
    INTEGER: "integer",
    INTEGER_OPTIONS: "integer-options",
    SELECT: "select",
    CHECKBOX_GROUP: "checkbox-group", // Values are stored as a JSON-serialized array and parsed back into an array when read
};
//# sourceMappingURL=appConfig.js.map